import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 z-10 rounded-xl"
}
const _hoisted_2 = { class: "flex items-start justify-between flex-1 gap-4" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "text-sm font-medium text-black mb-2" }
const _hoisted_5 = { class: "text-2xl font-bold text-black mb-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-xl font-normal text-black ml-1"
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-wrap items-center mt-3 gap-y-1"
}
const _hoisted_8 = {
  key: 1,
  class: "mt-3 flex min-w-0 justify-end"
}
const _hoisted_9 = { class: "min-w-0" }

import { computed } from 'vue';
import type { StatsCardProps, StatsCardEmits } from '../../types/dashboard';


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsCard',
  props: {
    title: {},
    value: {},
    suffix: {},
    icon: {},
    iconColor: {},
    iconBgColor: {},
    change: {},
    description: {},
    actionLabel: {},
    formatValue: { type: Boolean, default: true },
    clickable: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["action", "click"],
  setup(__props: any) {

const props = __props;

const formattedValue = computed(() => {
  const value = props.value;
  if (!props.formatValue || typeof value === 'string') {
    return value;
  }

  if (props.title?.toLowerCase().includes('chiffre d\'affaires')) {
    return value.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  
  if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + 'M';
  } else if (value >= 1000) {
    return (value / 1000).toFixed(1) + 'K';
  }
  
  return value.toLocaleString();
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'bg-white rounded-xl shadow-sm border border-gray-200 p-4 transition-all duration-300 relative flex min-w-0 h-full flex-col overflow-hidden',
      _ctx.clickable ? 'cursor-pointer hover:shadow-lg hover:border-blue-300' : 'cursor-default'
    ]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickable && _ctx.$emit('click')))
  }, [
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-6 w-6 border-2 border-gray-300 border-t-blue-500" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", _hoisted_5, [
          _createTextVNode(_toDisplayString(formattedValue.value) + " ", 1),
          (_ctx.suffix)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.suffix), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.change !== undefined && _ctx.change !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass([
            'flex items-center justify-center w-6 h-6 rounded-full mr-2',
            _ctx.change >= 0 ? 'bg-green-100' : 'bg-red-100'
          ])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass([
              'text-xs',
              _ctx.change >= 0 ? 'fas fa-arrow-up text-green-600' : 'fas fa-arrow-down text-red-600'
            ])
                }, null, 2)
              ], 2),
              _createElementVNode("span", {
                class: _normalizeClass([
            'text-sm font-semibold',
            _ctx.change >= 0 ? 'text-green-600' : 'text-red-600'
          ])
              }, _toDisplayString(Math.abs(_ctx.change)) + "% ", 3),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-xs text-black ml-2 font-medium" }, "vs mois dernier", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([
        'w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0',
        _ctx.iconBgColor || 'bg-blue-100'
      ])
      }, [
        _createElementVNode("i", {
          class: _normalizeClass([_ctx.icon, _ctx.iconColor || 'text-blue-600', 'text-xl leading-none'])
        }, null, 2)
      ], 2)
    ]),
    (_ctx.actionLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('action')), ["stop"])),
            class: "stats-card-action group inline-flex w-full max-w-full items-center justify-center gap-2 rounded-full bg-blue-50 px-3 py-1.5 text-center text-sm font-semibold leading-tight text-blue-600 transition-all duration-200 hover:bg-blue-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-200"
          }, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.actionLabel), 1),
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-arrow-right text-xs transition-transform duration-200 group-hover:translate-x-0.5" }, null, -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})